import { useEffect, useState } from 'react';
import { isSmartPhone, RoundedOffAmount } from '../../../../utilities/helper';
import { transactionEarningsBonusWallet } from '../../../../constants/transaction_history';
import IGamioEarningsMWeb from './index_mWeb';
import IGamioEarningsWeb from './index_web';
import constants from '../../../../constants';
const limit = constants.Limit.TRANSACTION_LIST;

const IGamioEarnings = () => {
  const [depositList, setDepositList] = useState([] as any);
  const [error, setError] = useState(false);
  const [resultArrived, setResultArrived] = useState(false);
  const [skip, setSkip] = useState(0);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [totalEarning, setTotalEarning] = useState(0);

  useEffect(() => {
    getData();
  }, []);

  const getData = (skip = 0) => {
    const result = transactionEarningsBonusWallet;
    setResultArrived(true);
    if (!error && result) {
      const { result: data = [], amount = 0 } = result;
      if (data.length < limit) {
        setHasMoreItems(false);
      }
      setSkip(skip + data.length);
      const roundedOffAmount = RoundedOffAmount(amount);
      setTotalEarning(roundedOffAmount);

      if (skip === 0) {
        setDepositList(data);
      } else {
        setDepositList((depositList: any) => [...depositList, ...data]);
      }
    } else {
      setError(true);
    }
  };

  const _onRefresh = async () => {
    setSkip(0);
    setHasMoreItems(true);
    getData();
  };

  const loadMoreItems = () => {
    if (!hasMoreItems) return;
    getData(skip);
  };

  const onPressRetryDeposit = () => {
    setResultArrived(false);
    getData();
  };

  return (
    <>
      {isSmartPhone ? (
        <IGamioEarningsMWeb
          onPressRetryDeposit={onPressRetryDeposit}
          resultArrived={resultArrived}
          error={error}
          totalEarning={totalEarning}
          _onRefresh={_onRefresh}
          depositList={depositList}
          hasMoreItems={hasMoreItems}
          loadMoreItems={loadMoreItems}
        />
      ) : (
        <IGamioEarningsWeb
          resultArrived={resultArrived}
          totalEarning={totalEarning}
          depositList={depositList}
        />
      )}
    </>
  );
};
export default IGamioEarnings;
